import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { routes } from '../MainPage'
import { useSelector } from 'react-redux'
import PageBanner from '../Components/Other/PageBanner'
import moment from 'moment';

function BlogInfo(props) {
  let { name } = useParams();
  let navigate = useNavigate();
  let location = useLocation()
  location.state == null && navigate(routes.home)
  const { description, created_date, image, title, update_date } =   location.state == null?{}:  location.state 
  useEffect(() => {
    location.state == null && navigate(routes.blog)
  }, [location])
  return (
    <PageWrapper className={"blog-page"}>
      <div className="pageWrapper">
        <PageBanner pageName={"Our Articles"}></PageBanner>
        <div className="MainContent">
          <div className="container">
            <div className="blog-content">
              <div className="container blog-container">
                <div className="blog-details">
                  <h2>{title}</h2>
                  <div className="blog-date">
                    <span>{moment(created_date).format('MMM Do, YYYY')}</span>
                  </div>
                </div>
                <div className="article-post-imgtxt">
                  <div className="article-post-img">
                    <img src={image} alt="Blog" />
                  </div>
                </div>
                <div className="blog-long-des" dangerouslySetInnerHTML={{ __html: description }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default BlogInfo;